import { useLoading } from "context/LoadingContext";
import { ToastContext } from "context/ToastContext";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateManyProfessionalRulesetsMutation } from "store/queries/professionalRuleset";

import {
  IProfessionalRulesetFormData,
  INITIAL_PROFESSIONAL_FORM_DATA,
  ProfessionalRulesetForm,
} from "./components/ProfessionalRulesetForm";

export function CreateProfessionalRulesetPage() {
  useDocumentTitle("Create Professional Ruleset");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();
  const { current: toastElement } = useContext(ToastContext);
  const [createManyMutation, { isLoading }] =
    useCreateManyProfessionalRulesetsMutation();
  const [formData, setFormData] = useState<IProfessionalRulesetFormData>(
    INITIAL_PROFESSIONAL_FORM_DATA
  );

  const handleSubmit = async () => {
    if (!formData.providerIds.length || !formData.payerIds.length) return;
    setIsLoading(true);
    try {
      const created = await createManyMutation({
        providerIds: formData.providerIds,
        payerIds: formData.payerIds,
        compoundBilateralAndMppr: formData.compoundBilateralAndMppr,
        endoApplies: formData.endoApplies,
        disabledEndoBaseCptCodes: formData.disabledEndoBaseCptCodes,
      }).unwrap();
      const count = created.data?.length ?? 0;
      toastElement?.show({
        severity: "success",
        summary: "Created!",
        detail: `${count} professional ruleset${
          count === 1 ? "" : "s"
        } created successfully.`,
      });
      navigate("/payer-rules");
    } catch (error: any) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail:
          error?.data?.message || "Failed to create professional rulesets",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ProfessionalRulesetForm
      title="Create Professional Rulesets"
      submitLabel="Create Rulesets"
      formData={formData}
      onChange={setFormData}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
      multiScope
    />
  );
}
